export default __webpack_public_path__ + "4b2e8a00146897684205df9707a533d7.png";